import React from "react";
import { View } from "features/global/reducer";
import { Button, Grid } from "@material-ui/core";
import { Club, IncreasedDataProtections } from "api/clubs";
import { useSelector } from "react-redux";
import i18n from "./i18n";
import "./b2bfeaturesStyle.scss";

interface AttentionBannerProps {
    onNavigateTo: ({ view, tab }: { view: View, tab?: number }) => void,
    club: Club,
}

const AttentionBanner = ({ onNavigateTo, club }: AttentionBannerProps) => {
    // handle navigation to subscription
    const userProfile = useSelector((state: any) => state.user.profile);
    const goToSubscriptionTab = () => {
        onNavigateTo({ view: View.Club, tab: 4 }); // subscription tab
    };
    const isRootUser = userProfile?.userTypes?.includes("root-management");
    const disableNavigation = (club?.increasedDataProtections?.includes(IncreasedDataProtections.SUBSCRIPTION) && !isRootUser);
    return (
        <>
            <Grid container>
                <Grid item xs={12} className="topWarningBanner">
                    {i18n.noActivePlanErrorMsg}
                    <Button
                        disabled={disableNavigation}
                        size="small"
                        className="subscriptionBtn"
                        onClick={() => {
                            goToSubscriptionTab();
                        }}
                        color="primary"
                        variant="outlined"
                    >
                        {i18n.subscriptionPlan}
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

export default AttentionBanner;
